import React from "react";

const Architecture = () => {
  return (
    <div className="max-w-screen-2xl mx-auto">
      <h1 className=" text-7xl text-white text-medium tracking-wide">
        Arts and Culturals
      </h1>
      <hr className="border-3 mt-2 bg-white" />
      <div className="mt-10">
        <h1 className="text-5xl text-white font-medium tracking-wide">
          Architectures
        </h1>
        <h2 className="text-2xl text-white font-normal mt-2 tracking-wide">
          สถาปัตยกรรมเชียงใหม่
        </h2>
      </div>
      <div className="bg-white shadow-md px-10 pt-10 pb-14 my-10">
        <div className="flex gap-8">
          <img
            src="https://media.discordapp.net/attachments/287239433517006848/964773624861036625/temple-1.jpg?width=849&height=566"
            alt="wat-tonkeawn"
            className="w-[810px] h-[540px] rounded-md shadow-md cursor-pointer hover:scale-105 transition duration-200"
          />
          <p className="w-fit h-fit bg-zinc-200 p-3 shadow-md indent-8 text-normal text-lg ">
            สถาปัตยกรรมในจังหวัดเชียงใหม่เป็นสถาปัตยกรรมที่ได้รับ
            การสืบทอดกันมาตั้งแต่ยุคสมัยอาณาจักรล้านนาโดยสถาปัตยกรรม
            ยุคแรกในช่วงพุทธศตวรรษที่ 19 ได้รับอิทธิพลจากศิลปะ
            หริภุญชัยและศิลปะพุกามจากพม่า ในช่วงพุทธศตวรรษที่ 20
            ได้รับอิทธิพลจากศิลปะสุโขทัย ต่อมาในศิลปะต้นถึงกลาง พุทธศตวรรษที่ 21
            ถือเป็นยุคทองมีการสร้างวัดและเจดีย์มากมาย ยุคถัดมาในช่วงกลางถึง
            ปลายพุทธศตวรรษที่ 21อาณาจักรล้านนา
            ตกอยู่ภายใต้การปกครองของพม่าถือเป็นยุคเสื่อมสถาปัตยกรรม
            ในช่วงยุคทองมีความสัมพันธ์อย่างยิ่งกับการเผย แพร่พุทธศาสนา ลังกาวงส์
            หรือ นิกายรามัญได้แรงบันดาลใจทั้งจากงาน สถาปัตยกรรมในยุคก่อน
            อิทธิพลจากสถาปัตยกรรมภายนอกดัง เช่นสุโขทัย พม่าสมัยพุกาม
          </p>
        </div>
        <h2 className="text-2xl font-normal mt-7">
          สถาปัตยกรรมที่สำคัญในจังหวัดเชียงใหม่
        </h2>
        <div className="flex mt-4 gap-8">
          <img
            src="https://media.discordapp.net/attachments/287239433517006848/964782874580635698/temple-2.jpg?width=849&height=566"
            alt="Wat Doi Suthep"
            className="w-[760px] h-[490px] rounded-md shadow-md cursor-pointer hover:scale-105 transtiion duration-200"
          />
          <div className="">
            <h1 className="text-xl font-normal text-center mb-4">
              วัดพระธาตุดอยสุเทพ
            </h1>
            <p className="w-fit h-fit bg-zinc-200 p-3 shadow-md indent-8 text-normal text-lg items-center">
              วัดพระธาตุดอยสุเทพ วัดที่มีความสำคัญมากที่สุดในเชียงใหม่
              ความโดดเด่นของวัดเริ่มตั้งแต่ทางขึ้นพระธาตุซึ่งเป็นบันไดนาค
              เจ็ดเศียรก่อปูน และเมื่อเดินเข้าไปภายในวัดจะพบเจดีย์ ทรงเชียงแสน
              ฐานสูง ย่อมุมระฆังทรงแปดเหลี่ยมปิดด้วยทอง
              ซึ่งก่อสร้างตามแบบศิลปะล้านนา อีกทั้งในบริเวณวัดยังเป็น
              จุดชมวิวเมืองเชียงใหม่ได้อย่างชัดเจนอีกแห่งหนึ่งด้วย นอกจากนี้
              ที่วัดพระธาตุดอยสุเทพยังมีการจัดงานประเพณี
              เตียวขึ้นดอยเพื่อสักการะพระบรมสารีริกธาตุเป็นประจำทุกปี
            </p>
          </div>
        </div>
        <div className="mt-14 flex justify-between gap-8">
          <div className="text-center text-xl relative">
            <h2 className="">ศูนย์สถาปัตยกรรมล้านนา</h2>
            <img
              src="https://media.discordapp.net/attachments/287239433517006848/964784962781999104/lannaarch.jpg?width=849&height=566"
              alt="Lanna Architecture Center"
              className="mt-3 rounded-md shadow-md cursor-pointer hover:scale-105 transtiion duration-200"
            />
            <a
              href="https://www2.arc.cmu.ac.th/lannaarch/"
              target="_blank"
              className="w-fit absolute right-0 bottom-[-10%] text-sm hover:text-blue-400"
            >
              more info →
            </a>
          </div>
          <div className="text-center text-xl relative">
            <h2>พระตำหนักภูพิงคราชนิเวศน์</h2>
            <img
              src="https://media.discordapp.net/attachments/287239433517006848/964784962173796392/palace.jpeg?width=848&height=566"
              alt="Palace"
              className="mt-3 rounded-md shadow-md cursor-pointer hover:scale-105 transtiion duration-200"
            />
            <a
              href="https://www.royaloffice.th/%E0%B8%9E%E0%B8%A3%E0%B8%B0%E0%B8%9A%E0%B8%A3%E0%B8%A1%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B8%B2%E0%B8%8A%E0%B8%A7%E0%B8%B1%E0%B8%87-%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%9E%E0%B8%A3%E0%B8%B0%E0%B8%A3/%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%B9%E0%B8%A5%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%A2%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A1%E0%B8%8A%E0%B8%A1/%E0%B8%9E%E0%B8%A3%E0%B8%B0%E0%B8%95%E0%B8%B3%E0%B8%AB%E0%B8%99%E0%B8%B1%E0%B8%81%E0%B8%A0%E0%B8%B9%E0%B8%9E%E0%B8%B4%E0%B8%87%E0%B8%84%E0%B9%8C%E0%B8%A3%E0%B8%B2%E0%B8%8A%E0%B8%99%E0%B8%B4%E0%B9%80/"
              target="_blank"
              className="w-fit absolute right-0 bottom-[-10%] text-sm hover:text-blue-400"
            >
              more info →
            </a>
          </div>
          <div className="text-center text-xl relative">
            <h2>พิพิธภัณฑ์เรือนโบราณ</h2>
            <img
              src="https://media.discordapp.net/attachments/287239433517006848/964784961443995698/museam.webp?width=1006&height=566"
              alt="Classic Thai House"
              className="mt-3 rounded-md shadow-md cursor-pointer hover:scale-105 transtiion duration-200"
            />
            <a
              href="https://www.wongnai.com/attractions/324894TD-%E0%B8%9E%E0%B8%B4%E0%B8%9E%E0%B8%B4%E0%B8%98%E0%B8%A0%E0%B8%B1%E0%B8%93%E0%B8%91%E0%B9%8C%E0%B9%80%E0%B8%A3%E0%B8%B7%E0%B8%AD%E0%B8%99%E0%B9%82%E0%B8%9A%E0%B8%A3%E0%B8%B2%E0%B8%93"
              target="_blank"
              className="w-fit absolute right-0 bottom-[-10%] text-sm hover:text-blue-400"
            >
              more info →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Architecture;
